import React from "react";

import * as SC from "./MainContent.styled";
import InteractionMetrics from "../InteractionMetrics/InteractionMetrics";
import TargetPerformance from "../TargetPerformance/TargetPerformance";
import ApplicantFunnel from "../ApplicantFunnel/ApplicantFunnel";
import ApplicantRatings from "../ApplicantRatings/ApplicantRatings";
import { withRouter } from "react-router-dom";
import { withRefluxStore } from "../../../../Stores";
import { Store__System } from "@talentbait/shared-components";
import {
  useEnrichedDailyData,
  usePerformanceMetrics
} from "../../../../hooks/use-enriched-data.hook";
import logger from "../../../../utils/LoggerFrontend";
import ApplicantPlatforms from "../ApplicantPlatforms/ApplicantPlatforms";

// campaign/:orgaId/:id
const MainContent = ({
  campaignData,
  isOldView = false,
  range,
  //Store
  userProfile
}) => {
  const { metrics } = useEnrichedDailyData(campaignData?.id, range);
  const chartData = usePerformanceMetrics(campaignData?.id, range);

  const {
    statusBreakdown = {},
    platformBreakdown = {},
    ratingsBreakdown = [],
    averageRating
  } = metrics || {};

  const campaignGoalIsApplicants = campaignData?.campaignGoal === "applicants";
  const statuses = Object.values(statusBreakdown)?.[0] || [];
  const platforms = Object.values(platformBreakdown)?.[0] || [];
  const totalCandidates = platforms?.reduce((sum, item) => sum + item?.value || 0, 0);

  logger.debug("DataVisualisation:MainContent", "rendering 'New View' charts", {
    campaignGoal: campaignData?.campaignGoal,
    metrics,
    statuses,
    platforms,
    averageRating,
    ratingsBreakdown,
    range,
    chartData
  });

  return (
    <SC.Layout isOldView={isOldView}>
      {campaignGoalIsApplicants && (
        <SC.Group>
          <ApplicantPlatforms
            platforms={platforms}
            language={userProfile?.language}
            totalAmount={totalCandidates}
          />
          <ApplicantRatings
            ratings={ratingsBreakdown}
            language={userProfile?.language}
            averageRating={averageRating}
          />
          <ApplicantFunnel statuses={statuses} />
        </SC.Group>
      )}
      <InteractionMetrics chartData={chartData} />
      <TargetPerformance chartData={chartData} />
    </SC.Layout>
  );
};

export default withRouter(withRefluxStore(MainContent, [Store__System], ["userProfile"]));
